import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { Pill } from './Pill';
import { bonusValueRows } from '../data/bonuses';
import { bonusValue, brandName, fullPrice, included, volumesValue } from '../data/copy';
const systemParts = [{
  value: '6',
  label: 'Volumi tecnici'
}, {
  value: '72',
  label: 'Sessioni da 60 minuti'
}, {
  value: '5',
  label: 'Bonus operativi'
}];
export function OfferSection() {
  return <section id="oferta" className="defer-paint w-full scroll-mt-6 bg-paper py-10 sm:py-16" aria-labelledby="offer-heading" data-id="element-130" data-mp="me1xrddm21jj">
      <div className="mx-auto max-w-5xl px-5 sm:px-6" data-id="element-131" data-mp="refx8715c35y">
        <div className="mx-auto max-w-xl text-center" data-id="element-132" data-mp="wdj4zz8ignhm">
          <Pill tone="pine" data-id="element-133" data-mp="wawxu0pj89zx">Il tuo accesso completo oggi</Pill>
          <h2 id="offer-heading" className="mt-3 font-display text-[2.6rem] font-bold uppercase leading-none text-pine sm:text-6xl" data-id="element-134" data-mp="2t6b50bka7niw">
            {brandName}
          </h2>

          {/* La formula del sistema completo: tre numeri uniti da "+". */}
          <div className="mt-4 rounded-2xl border border-line bg-paper-soft px-3 py-3 sm:px-5" data-id="element-135" data-mp="12pczp42fobzo">
            <p className="font-display text-[11px] font-medium uppercase tracking-[0.18em] text-ink-muted" data-id="element-136" data-mp="xuyz8n8wzeo5">
              Sistema completo
            </p>
            <dl className="mt-1.5 grid grid-cols-[1fr_auto_1fr_auto_1fr] items-center" data-id="element-137" data-mp="ox577oi6n76s">
              {systemParts.map((part, index) => <React.Fragment key={part.label} data-id="element-138" data-mp="1lll64b76mswk" data-mpi={index}>
                  <div className="flex flex-col-reverse items-center px-1" data-id="element-139" data-mp="1gmrtekzpz5xg">
                    <dt className="mt-1 font-display text-[10px] font-medium uppercase leading-tight tracking-[0.08em] text-ink-muted sm:text-xs" data-id="element-140" data-mp="1clod5xdrf7vp">
                      {part.label}
                    </dt>
                    <dd className="font-display text-3xl font-bold leading-none text-pine sm:text-4xl" data-id="element-141" data-mp="169gkupgqi14">
                      {part.value}
                    </dd>
                  </div>
                  {index < systemParts.length - 1 ? <span className="font-display text-2xl font-bold text-ember" aria-hidden="true" data-id="element-142" data-mp="3ttq06ftfrxfv">
                      +
                    </span> : null}
                </React.Fragment>)}
            </dl>
          </div>
        </div>

        <div className="mt-6 grid sm:mt-8 gap-6 lg:grid-cols-[1fr_1.1fr] lg:gap-8" data-id="element-143" data-mp="3ksrxq1ynbxze">
          {/* Su mobile il countdown e il prezzo vengono prima, così il CTA
              dell'hero atterra direttamente sull'offerta. */}
          <div className="contents lg:flex lg:flex-col lg:gap-6" data-id="element-144" data-mp="3b1ouati8v6wy">
            <div className="order-1 lg:order-none" data-id="element-145" data-mp="3fvt1ndvf9gyk">
              <CountdownTimer data-id="element-146" data-mp="315luhuav7kd6" />
            </div>

            <div className="order-3 rounded-2xl border border-line bg-paper-soft p-6 sm:p-7 lg:order-none" data-id="element-147" data-mp="316wxhrwhko38">
              <h3 className="font-display text-xl font-bold uppercase text-ink" data-id="element-148" data-mp="364omoe5qxw3q">
                Quanto vale separatamente
              </h3>
              <ul className="mt-4 divide-y divide-line" data-id="element-149" data-mp="2x3gzar4rqfof">
                <li className="flex items-baseline justify-between gap-4 py-3 font-sans text-sm text-ink" data-id="element-150" data-mp="2x2xm1nq2cfgq">
                  <span data-id="element-151" data-mp="2dk1f1onroiqa">6 volumi tecnici — 72 sessioni</span>
                  <span className="shrink-0 font-semibold text-ink-muted" data-id="element-152" data-mp="28jvqihcsnccf">{volumesValue}</span>
                </li>
                {bonusValueRows.map(row => <li key={row.label} className="flex items-baseline justify-between gap-4 py-3 font-sans text-sm text-ink" data-id="element-153" data-mp="2mgadb000dbau">
                    <span data-id="element-154" data-mp="2wgjaoh5ql2rt">{row.label}</span>
                    <span className="shrink-0 font-semibold text-ink-muted" data-id="element-155" data-mp="2wf8bkun8kj71">{row.value}</span>
                  </li>)}
              </ul>
              <div className="mt-2 flex items-baseline justify-between gap-4 border-t-2 border-pine pt-4" data-id="element-156" data-mp="2rfvktyt8urz6">
                <span className="font-display text-sm font-semibold uppercase tracking-[0.12em] text-pine" data-id="element-157" data-mp="317jco0tpqb16">
                  Valore totale del sistema
                </span>
                <span className="font-display text-4xl font-bold leading-none text-pine" data-id="element-158" data-mp="3f57wd5c1nc4n">
                  {fullPrice}
                </span>
              </div>
              <p className="mt-4 font-sans text-sm leading-relaxed text-ink-muted" data-id="element-159" data-mp="18hz5s0f3fczh">
                I 5 bonus ({bonusValue}) sono inclusi oggi senza costi
                aggiuntivi.
              </p>
            </div>
          </div>

          <div className="order-2 rounded-2xl bg-pine p-6 text-center text-paper-soft shadow-xl shadow-pine/25 sm:p-9 lg:order-none" data-id="element-160" data-mp="1iay3c7skidv8">
            <h3 className="font-display text-2xl font-bold uppercase tracking-wide" data-id="element-161" data-mp="pkfu0p193g9d">
              Offerta di lancio
            </h3>
            <p className="mt-2 font-sans text-sm text-pine-light" data-id="element-162" data-mp="uk23qohveedf">
              Valore normale:{' '}
              <span className="line-through" data-id="element-163" data-mp="yk2vtbxw6o2y">{fullPrice}</span>
            </p>
            <p className="mt-2 flex items-start justify-center gap-1 font-display font-bold leading-none" data-id="element-164" data-mp="13k79yvbbv6q0">
              <span className="mt-4 text-3xl" data-id="element-165" data-mp="29yzmeq9q5lcf">€</span>
              <span className="text-[6rem] leading-none sm:text-[7rem]" data-id="element-166" data-mp="2ez42wgamug2n">19</span>
            </p>
            <p className="mt-2 font-sans text-xs uppercase tracking-[0.14em] text-pine-light" data-id="element-167" data-mp="2f0xco4gjlgev">
              Un solo pagamento · nella tua valuta locale
            </p>

            <h4 className="mt-6 text-left font-display text-base font-semibold uppercase tracking-[0.12em]" data-id="element-168" data-mp="2k4hkc82n0p7g">
              Cosa riceverai
            </h4>

            <ul className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1.5 border-t border-paper-soft/20 pt-3 text-left sm:gap-x-5" data-id="element-169" data-mp="2bc6053y49xzx">
              {included.map(item => <li key={item} className="flex items-start gap-1.5 font-sans text-xs leading-snug text-paper-soft sm:text-sm" data-id="element-170" data-mp="26dupws3wtlh6">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-pine-light" strokeWidth={2.8} aria-hidden="true" data-id="element-171" data-mp="1wedkmbskl9lq" />
                  {item}
                </li>)}
            </ul>

            <CtaButton size="large" className="mt-6 w-full" data-id="element-172" data-mp="1sf4r981fzdqp">
              Accedi al sistema completo ora
            </CtaButton>

            <p className="mt-4 text-center font-sans text-xs text-pine-light" data-id="element-173" data-mp="3mq9re2dbl81a">
              Pagamento sicuro · accesso immediato · garanzia di 7 giorni
            </p>
          </div>
        </div>
      </div>
    </section>;
}